'use client';

import { useEffect, useState } from 'react';

import { useAuthContext } from '@/components/Providers/AuthProvider';
import RankUp from '@/components/V2/Reports/RankUp';
import { useLazyGetRankUpWidgetQuery } from '@/store/api/reports';
import { DashboardMetaData } from '@/types/Dashboard';
import { RankUpWidgetResponse } from '@/types/Reports';
import { SuccessResponse } from '@/types/Success';

interface DashboardRankUpProps {
  metaLoading: boolean;
  metaData: DashboardMetaData | undefined;
}

const DashboardRankUp = ({ metaLoading, metaData }: DashboardRankUpProps) => {
  const { customer } = useAuthContext();
  const [rankData, setRankData] = useState<RankUpWidgetResponse>();
  const [selectedRankID, setSelectedRankID] = useState<number | undefined>();
  const [isLoading, setIsLoading] = useState(true);

  const [
    triggerGetRankupWidget,
    { isFetching: isFetchingRankupInfo, isLoading: isLoadingRankupInfo, currentData: rankUpInfoResp },
  ] = useLazyGetRankUpWidgetQuery();

  useEffect(() => {
    if (customer?.customerID && !metaLoading) {
      setIsLoading(true);
      triggerGetRankupWidget({
        custid: 0,
        // careerrankid: customer.careerRankId,
        faststartenddate: metaData?.fastStartEndDate || '0001-01-01T00:00:00',
        rankid: selectedRankID,
        date2: metaData?.date2,
      })
        .unwrap()
        .then((response: SuccessResponse<RankUpWidgetResponse>) => {
          setRankData(response.data);
        })
        .catch(error => console.error('Error fetching Rank data:', error))
        .finally(() => {
          setIsLoading(false);
        });
    }
  }, [
    customer?.customerID,
    metaData?.date2,
    metaData?.fastStartEndDate,
    metaLoading,
    selectedRankID,
    triggerGetRankupWidget,
  ]);

  return (
    <div className="v2-shadow-md v2-p-[24px] md:v2-p-[24px] sm:v2-p-4 xs:v2-p-4 v2-bg-white v2-rounded-xs">
      <div className="v2-pb-5">
        <h2 className="v2-text-[#333333] v2-font-sweet-sans-pro-bold v2-font-bold v2-text-xl v2-text-center">
          Rank Up
        </h2>
      </div>
      <div>
        <RankUp
          loading={isFetchingRankupInfo || isLoadingRankupInfo || isLoading}
          isDashboard={true}
          isTreeViewer={true}
          data={rankData || undefined}
          setSelectedRankID={id => setSelectedRankID(id)}
          // className="v2-pt-[12px]"
        />
      </div>
    </div>
  );
};

export default DashboardRankUp;
